import { useModalStore } from "../../store/modalStore";
import { AdminPanelSettings, Edit } from "@mui/icons-material";
import { capitalizeFirstLetter } from "../../utils/strings";
import CloseIcon from "@mui/icons-material/Close";

import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Chip,
  Grid,
} from "@mui/material";
import axiosInstance from "../../services/axiosInstance";
import { toast } from "sonner";

const ChangeRoleModal = () => {
  const isRoleModalOpen = useModalStore((state) => state.isRoleModalOpen);
  const roleEmail = useModalStore((state) => state.roleEmail);
  const role = useModalStore((state) => state.role);
  const setRoleModalOpen = useModalStore((state) => state.setRoleModalOpen);
  const roleReset = useModalStore((state) => state.roleReset);

  const roleModalCloseHandler = () => {
    setRoleModalOpen(false);
    roleReset();
  };

  // Handle change password
  const handleChangeRole = async () => {
    const payload = { email: roleEmail, role };

    try {
      await axiosInstance.post(`/api/v1/users/change-role`, payload);
      setRoleModalOpen(false);
      roleReset();
      window.location.reload();
    } catch (error: any) {
      toast.error("Error changing user role. Please try again.");
    }
  };

  return (
    <>
      {isRoleModalOpen && (
        <Dialog
          open={isRoleModalOpen}
          onClose={roleModalCloseHandler}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "0.938rem",
              height: "auto",
            },
          }}
        >
          <Grid
            container
            display={"flex"}
            justifyContent={"space-between"}
            p={1}
            sx={{
              backgroundColor: "#343434",
              color: "white",
            }}
          >
            <Typography variant="h6">{"Change Role"}</Typography>
            <Grid
              item
              onClick={roleModalCloseHandler}
              mt={0.2}
              sx={{
                cursor: "pointer",
              }}
            >
              <CloseIcon />
            </Grid>
          </Grid>
          <DialogContent>
            <Typography fontWeight={600} fontSize={24}>
              Change <span style={{ color: "darkmagenta" }}>{roleEmail}</span>{" "}
              to role{" "}
              <Chip
                label={role ? capitalizeFirstLetter(role) : ""}
                icon={role === "admin" ? <AdminPanelSettings /> : <Edit />}
              />{" "}
              ?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="outlined"
              onClick={roleModalCloseHandler}
              color="error"
              sx={{
                borderRadius: 2,
              }}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={handleChangeRole}
              color="secondary"
              sx={{
                borderRadius: 2,
              }}
            >
              Change Role
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ChangeRoleModal;
